import controller from './details.controller';
import template from './details.html';

const servicesDetailsComponent = {
  restrict: 'E',
  template,
  controller
};

export default servicesDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/details/details.component.js
 **/